import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { GridColDef, GridRowParams } from '@mui/x-data-grid';
import { format, isValid } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import enLocale from 'date-fns/locale/en-US';
import frLocale from 'date-fns/locale/fr-CA';
import useTimezone from 'hooks/useTimezone';
import useUser from 'hooks/useUser';
import { useModal } from 'mui-modal-provider';
import { useCallback, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import BasicTable from 'views/components/BasicTable';
import PreviewFormBuilder from 'views/components/form-builder/PreviewFormBuilder';

const useStyles = makeStyles(() => ({
  Incomplete: {
    backgroundColor: '#f2dede',
    '&:hover': {
      backgroundColor: '#ebcccc !important'
    }
  },
  Completed: {
    backgroundColor: 'inherit'
  }
}));

interface Props {
  user: any;
  clientResponses: any;
  index: any;
  isForm: boolean;
  row: any;
}

interface ClientFormRow {
  id: 'assigned-form';
  version: string;
  submissionDate: string;
  // status: string;
  therapist: string;
  assignedDate: string;
}

export default function DocumentAssignedFormsClientResponses({ user, clientResponses, index, isForm, row }: Props) {
  const intl = useIntl();
  const { user: therapist } = useUser(user?.therapist);
  const classes = useStyles();
  const { timezone } = useTimezone();
  const { showModal } = useModal();

  const handleFormBuilderForm = useCallback(
    (version) => {
      console.log(version, 'version');
      // const isForm = assignedForm?.form ? true : false;
      const clientResponse = row?.assignedFormData?.clientResponses;
      const type = isForm ? row?.assignedFormData?.form?.type : row?.assignedFormData?.template?.type;
      const initialValues = isForm
        ? type === 'default'
          ? clientResponse[version]?.form?.items
          : clientResponse[version]?.form?.steps
        : type === 'default'
        ? clientResponse[version]?.template?.items
        : clientResponse[version]?.template?.steps;
      console.log(row, clientResponses, 'rc', initialValues, type, clientResponse[version]?.form, isForm);
      return showModal(PreviewFormBuilder, {
        type: type,
        steps: initialValues,
        initialValues: initialValues,
        defaultTypeTitle: type === 'default' && row.name,
        collectScores: true,
        title: row?.assignedFormData[isForm ? 'form' : 'template']?.name,
        description: row?.assignedFormData[isForm ? 'form' : 'template']?.description
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [row, isForm, showModal]
  );
  const columns: GridColDef[] = [
    {
      field: 'version',
      headerName: intl.formatMessage({ defaultMessage: 'Version History' }),
      minWidth: 160,
      renderCell: (params) => {
        const row = params.row as ClientFormRow;
        return row.version + 1;
      }
    },
    {
      field: 'therapist',
      headerName: intl.formatMessage({ defaultMessage: 'Provider' }),
      minWidth: 150,
      renderCell: (params) => {
        const row = params.row as ClientFormRow;
        return <strong>{row.therapist}</strong>;
      }
    },
    {
      field: 'submissionDate',
      headerName: intl.formatMessage({ defaultMessage: 'Filled On' }),
      width: 300,
      renderCell: (params) => {
        const row = params.row as ClientFormRow;
        const lastUpdateMoment = new Date(new Date(row?.submissionDate).toUTCString());
        console.log(row?.submissionDate, 'rs');
        console.log('lastUpdateMoment : ', lastUpdateMoment);

        return isValid(lastUpdateMoment)
          ? format(utcToZonedTime(lastUpdateMoment, timezone), intl.locale === 'fr' ? 'do MMMM yyyy, HH:mm' : 'MMMM do yyyy, h:mm a', {
              locale: intl.locale === 'fr' ? frLocale : enLocale
            })
          : '-';
      }
    },
    {
      field: '',
      renderCell: (params) => {
        return (
          <Button color="secondary" variant="contained" onClick={() => handleFormBuilderForm(params.row.version)}>
            <FormattedMessage defaultMessage="Quick View" />
          </Button>
        );
      }
    }
  ];

  const rows = useMemo(() => {
    // only add the intake if enabled
    const result: ClientFormRow[] = [];

    clientResponses?.forEach((clientResponse, index) => {
      result.push({
        id: clientResponse._id,
        version: index,
        assignedDate: clientResponse?.assignedDate,
        submissionDate: clientResponse?.submissionDate,
        // status: clientResponse.acceptedOn ? 'Accepted' : '-',
        therapist: (therapist?.firstName ?? '') + ' ' + (therapist?.lastName ?? '')
      });
    });

    return result;
  }, [therapist, clientResponses]);

  return (
    <BasicTable
      emptyMessage={<FormattedMessage defaultMessage="No assigned form history found." />}
      columns={columns}
      rows={rows}
      getRowClassName={(params: GridRowParams) => classes[params?.row?.status]}
      paginationMode="client"
      pageSize={5}
      hideSearch
      sx={{
        backgroundColor: '#e3f2fd'
      }}
    />
  );
}
